<template>
  <svg aria-hidden="true" ...attributes xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2000 440.7">
    <g>
      <path
        d="M379.4,0v303.6h-75.9V75.9H113.8c-21,0-37.9,17-37.9,37.9v75.9c0,62.9,51,113.8,113.8,113.8h113.8v75.9h-113.8C84.9,379.4,0,294.5,0,189.7v-113.8h37.9c21,0,37.9-17,37.9-37.9V0h303.6Z"
      />
      <g>
        <path
          d="M561.5,186.1c0-102.8,49.5-164.8,138.4-164.8s115.3,39.4,125.9,113h-54.2c-7.9-44.9-32.9-66.7-73.2-66.7s-83.3,43.1-83.3,118.5,29.2,118.5,86.6,118.5,75.5-34.2,75.5-83.3v-9.7h-72.2v-44h122.2v181.5h-41.3l-4.6-42.2c-15.7,27.3-43.1,44-85.2,44-83.3,0-134.7-64.4-134.7-164.8Z"
        />
        <path d="M1048,303.6v45.7h-182.1l-.5-45.6h67.4l.5-227.8h-67.4V30.4h117.4v273.2h64.7Z" />
        <path
          d="M1118,241.2v2.3c1.4,40.3,26.4,66.7,65.3,66.7s52.3-15.3,58.8-41.7h50c-8.3,46.8-47.7,82.4-106,82.4s-120.4-48.2-120.4-120.8,46.3-121.8,115.3-121.8,113.9,43.5,115.3,113c0,5.1-.5,13-1.4,19.9h-176.9ZM1119.9,203.7h124.5c-4.2-35.2-28.2-55.1-63-55.1s-57.9,21.3-61.6,55.1Z"
        />
        <path
          d="M1325,269.9h49.1c1.9,24.5,23.1,42.1,58.8,42.1s50-12,50-31-21.3-27.3-56.9-31.9c-53.7-6.5-95.8-18.1-95.8-67.1s39.8-73.6,95.8-73.6,98.6,26.9,101.9,75.5h-49.1c-2.8-21.8-22.7-37-51.9-37s-48.2,12-48.2,31,22.7,25,56.5,28.7c52.8,6.5,96.8,17.6,96.8,70.4s-42.6,74.1-99.5,74.1-105.6-29.6-107.4-81Z"
        />
        <path
          d="M1554.6,440.7v-44h39.4c19.4,0,24.1-4.6,31.5-24.1l9.3-23.1-93.5-238.4h53.2l68.1,180.1,67.1-180.1h53.2l-109.7,274.1c-14.8,38.4-25,55.6-60.2,55.6h-58.3Z"
        />
        <path
          d="M1793,269.9h49.1c1.9,24.5,23.1,42.1,58.8,42.1s50-12,50-31-21.3-27.3-56.9-31.9c-53.7-6.5-95.8-18.1-95.8-67.1s39.8-73.6,95.8-73.6,98.6,26.9,101.9,75.5h-49.1c-2.8-21.8-22.7-37-51.9-37s-48.2,12-48.2,31,22.7,25,56.5,28.7c52.8,6.5,96.8,17.6,96.8,70.4s-42.6,74.1-99.5,74.1-105.6-29.6-107.4-81Z"
        />
      </g>
    </g>
  </svg>
</template>
